import React, { Component } from "react";
import PropTypes from "prop-types";
import httpClient from "lc-http";
import Row from "../../shared_modules/common/grid/Row";
import Col from "../../shared_modules/common/grid/Col";
import Icon from "../../shared_modules/common/icons/Icon";
import ValidationMsg from "../../shared_modules/common/forms/ValidationMsg";

let timeoutID;
const apiRetryWait = 500,
  apiNumRetry = 10;

const AGENT = "agent";

const validateEmail = (options) => {
  const { path, params } = options;
  return httpClient
    .post(path, { params })
    .then((response) => {
      const {
        data: { emailExists },
      } = response;
      return !emailExists;
    })
    .catch((error) => {
      throw error;
    });
};

class Email extends Component {
  constructor(props) {
    super(props);

    this.state = {
      msgData: {
        errors: { email: {} },
        info: { email: {} },
      },
      currentEmail: "",
      checkingEmailUnique: false,
      currentEmailUnique: null,
      apiFail: null,
    };
  }

  static defaultProps = {
    element: {
      name: "email",
      prefix: "pf-contact-",
      id: "pf-contact-email",
      label: "Email Address",
      placeHolder: "JohnDoe@somewhere.com",
      colLabelClassName: "label",
      colFieldClassName: "field",
      colValidationClassName: "messaging",
      maxLength: 50,
    },
    site: "LCPS",
    verifyEmailPath: "/patientsolutions/app/check-your-rate/check-email",
    emailEsignMsg:
      "Email is required in order to electronically receive and accept your documents.",
    emailRequiredMsg: "Please enter a valid email address.",
    emailAPIErrorMsg:
      "Unable to check, currently. Please retype your email in a few moments.",
    emailNotUniqueMsg:
      "The email address you entered already exists from a previous application. Please apply using a different valid email address.",
    emailReqInfoMsg: "A valid email address is required.",
    colLayout: {
      1: { sm: 12, lg: 3 },
      2: { sm: 12, lg: 3 },
      3: { sm: 12, lg: 6 },
    },
    userType: "applicant",
  };

  componentWillUnmount() {
    clearTimeout(timeoutID);
  }

  componentDidMount = () => {
    const email = this.props.fieldMetadata.value;

    if (email) {
      const { userType, verifyEmailPath: path, site } = this.props;

      const options = {
        params: {
          email,
          site,
          isProvider: userType === AGENT,
        },
        path,
      };

      setTimeout(() => {
        validateEmail(options)
          .then((emailIsUnique) => {
            const msgData = this.setFieldStatus(
              true,
              true,
              emailIsUnique,
              false,
            );
            this.setState({
              checkingEmailfUnique: false,
              currentEmailUnique: emailIsUnique,
              apiFail: false,
              currentEmail: email,
              msgData,
            });
          })
          .catch(() => {
            const msgData = this.setFieldStatus(true, true, null, true);
            this.setState({
              checkingEmailUnique: false,
              apiFail: true,
              msgData,
            });
          });
      }, 100);
    }
  };

  initMsgObj = () => {
    const { element } = this.props,
      msgData = {
        errors: {},
        info: {},
      };

    msgData.errors[element.name] = {};
    msgData.info[element.name] = {};

    return msgData;
  };

  generateMessage = (msgType, isUnique = null, apiFail = null) => {
    const {
      element,
      emailEsignMsg,
      emailNotUniqueMsg,
      emailAPIErrorMsg,
      emailRequiredMsg,
      emailReqInfoMsg,
      inEmailVerificationPilot,
    } = this.props;

    const notation = msgType === "error" ? "errors" : "info";
    const msgData = this.initMsgObj();

    let msg = "";

    // on focus
    if (msgType === "info") {
      msg = inEmailVerificationPilot ? emailReqInfoMsg : emailEsignMsg;
      // didnt validate
    } else if (msgType === "error") {
      if (apiFail === true) {
        msg = emailAPIErrorMsg;
      } else if (isUnique === false) {
        msg = emailNotUniqueMsg;
      } else {
        msg = emailRequiredMsg;
      }
    }

    msgData[notation][element.name] = {
      type: msgType,
      msg: msg,
      id: element.id,
      slug: element.name,
    };

    return msgData;
  };

  isEmptyNotRequired = (value) => {
    const { isRequired } = this.props.fieldMetadata,
      hasNoValue = value === "" || value === undefined;
    return hasNoValue && !isRequired ? true : false;
  };

  isFormatValid = (value) => {
    if (value.indexOf("xn--") !== -1) {
      return false;
    }
    const emailRegex =
      /^[_A-Za-z0-9-\+]+(\.[_A-Za-z0-9-\+]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/;
    return emailRegex.test(value);
  };

  tellPI1FormWait(str) {
    const { updateAsyncState } = this.props,
      startWait = { email: { shouldWait: true, asyncComplete: false } },
      stopWait = { email: { shouldWait: false, asyncComplete: true } },
      state = str === "start" ? startWait : stopWait;
    updateAsyncState(state);
  }

  updateParentSection(ev, data) {
    const { onEventCallback } = this.props;
    if (onEventCallback && typeof onEventCallback === "function") {
      onEventCallback(ev, data);
    }
  }

  validateEmailIsUnique(email) {
    // PF-20069
    let numTries = 0,
      callCompleted = null,
      msgData;

    const { userType, fieldMetadata, verifyEmailPath, site } = this.props,
      origin = window.location.origin,
      verifyEmailUrl = origin + verifyEmailPath,
      params = { email, site, isProvider: userType === AGENT },
      isEmptyNotRequired = this.isEmptyNotRequired(email);

    // make sure state already set correctly
    if (fieldMetadata.value !== email) {
      fieldMetadata.value = email;
    }

    // function will recurse if call fails in order to retry
    const callToValidate = () => {
      httpClient
        .post(verifyEmailUrl, { params })
        .then((result) => {
          // update with success, in case has been changed by failures
          numTries = numTries + 1;
          callCompleted = true;

          const { emailExists } = result.data,
            emailIsUnique = !(emailExists === true),
            theEvent = { target: { name: "email" } };

          msgData = this.setFieldStatus(
            isEmptyNotRequired,
            true,
            emailIsUnique,
          );

          // update Email local component state
          this.setState({
            checkingEmailUnique: false,
            currentEmailUnique: emailIsUnique,
            apiFail: false,
            msgData,
          });

          // tell section about new state
          this.updateParentSection(theEvent, fieldMetadata);
          // tell PI1 Form comp about Email async check
          this.tellPI1FormWait("stop");
        })
        .catch((error) => {
          // handle failures of call to API
          callCompleted = false;
          const theEvent = { target: { name: "email" } };

          // stop retrying, display error text
          if (numTries >= apiNumRetry && callCompleted === false) {
            // update local msg, err state
            msgData = this.setFieldStatus(
              isEmptyNotRequired,
              false,
              null,
              true,
            );
            this.setState({
              checkingEmailUnique: false,
              apiFail: true,
              msgData,
            });

            // tell section about new state
            this.updateParentSection(theEvent, fieldMetadata);
            // tell PI1 Form comp about Email async check
            this.tellPI1FormWait("stop");

            // 'email is unique' call failed, try again
          } else if (numTries < apiNumRetry && callCompleted === false) {
            numTries = numTries + 1;
            timeoutID = setTimeout(callToValidate, apiRetryWait);
          }
        });
    };

    if (numTries === 0 && callCompleted === null) {
      callToValidate();
    }
  }

  handleChange = (ev) => {
    const eventRecord = { ...ev };
    const { fieldMetadata } = this.props;
    fieldMetadata.value = ev.target.value;
    this.setState(
      {
        currentEmail: ev.target.value,
      },
      () => this.updateParentSection(eventRecord, fieldMetadata),
    );
  };

  setFieldStatus(
    isOkEmpty = false,
    isFormatValid = false,
    isUniq = null,
    apiFail = null,
  ) {
    let msgData = this.initMsgObj();
    const { fieldMetadata } = this.props;

    // api call fails after X retries (rarely occurs)
    if (apiFail === true) {
      msgData = this.generateMessage("error", isUniq, apiFail);
      fieldMetadata.isValid = false;
      fieldMetadata.status = "invalid";
      // value is empty, field not required, format is invalid
    } else if (
      isOkEmpty === true &&
      isFormatValid === false &&
      isUniq === null
    ) {
      fieldMetadata.isValid = true;
      fieldMetadata.status = "";
      // format is invalid
    } else if (isFormatValid === false && isUniq === null) {
      msgData = this.generateMessage("error", isUniq);
      fieldMetadata.isValid = false;
      fieldMetadata.status = "invalid";
      // format is valid, but email NOT uniq
    } else if (isFormatValid === true && isUniq === false) {
      msgData = this.generateMessage("error", isUniq);
      fieldMetadata.isValid = false;
      fieldMetadata.status = "invalid";
      // email format is valid AND unique
    } else if (isFormatValid === true && isUniq === true) {
      fieldMetadata.isValid = true;
      fieldMetadata.status = "";
      // format valid, but still requires uniq check
    } else if (isFormatValid === true && isUniq === null) {
      fieldMetadata.isValid = false;
      fieldMetadata.status = "checking";
    }

    return msgData;
  }

  handleBlur = (ev) => {
    let fieldFormatIsValid, fieldIsEmptyNotReq, msgData;
    const { currentEmail } = this.state,
      { fieldMetadata } = this.props;

    fieldMetadata.value = currentEmail;
    fieldIsEmptyNotReq = this.isEmptyNotRequired(currentEmail);
    fieldFormatIsValid = this.isFormatValid(currentEmail);

    // DON'T run validation if its empty and not required:
    // this scenario is okay for Providers, but not Applicants
    if (fieldIsEmptyNotReq === true) {
      msgData = this.setFieldStatus(fieldIsEmptyNotReq, false);
      this.updateParentSection(ev, fieldMetadata);
      this.setState({
        msgData,
        currentEmailUnique: null,
      });

      // FAIL initial validity checks
      // dont continue to async 'email is uniq'
    } else if (fieldFormatIsValid === false) {
      msgData = this.setFieldStatus(fieldIsEmptyNotReq, fieldFormatIsValid);
      this.updateParentSection(ev, fieldMetadata);
      this.setState({
        msgData,
        currentEmailUnique: null,
      });

      // PASS initial validity checks
      // CONTINUE w/ async emailIsUnique check
    } else if (fieldFormatIsValid === true) {
      msgData = this.setFieldStatus(false, fieldFormatIsValid, null);

      // update Email comp state
      this.setState({
        msgData,
        checkingEmailUnique: true,
        currentEmailUnique: null,
      });

      // tell parent PI1 form about starting to check state
      this.tellPI1FormWait("start");

      // start async validation
      this.validateEmailIsUnique(currentEmail, ev);
    }
  };

  handleFocus = (ev) => {
    const { fieldMetadata } = this.props;
    fieldMetadata.status = "";
    this.setState({
      msgData: this.generateMessage("info"),
    });
  };

  render() {
    const { colLayout, element, fieldMetadata } = this.props,
      { isValid, status } = fieldMetadata,
      { maxLength } = element;

    let fieldIsValid,
      iconProps = {},
      {
        msgData,
        currentEmail,
        checkingEmailUnique,
        currentEmailUnique,
        apiFail,
      } = this.state,
      isValidandUniq = isValid === true && currentEmailUnique;
    const fieldIsEmptyNotReq = this.isEmptyNotRequired(currentEmail);

    if (checkingEmailUnique === true) {
      iconProps.type = "spinner";
    } else if (isValidandUniq === true) {
      iconProps.type = "success";
    }

    if (status === "invalid") {
      fieldIsValid = this.isFormatValid(currentEmail);

      if (!fieldIsEmptyNotReq && !fieldIsValid) {
        msgData = this.setFieldStatus(fieldIsEmptyNotReq, fieldIsValid);
      } else if (fieldIsValid && !(currentEmailUnique === false)) {
        msgData = this.setFieldStatus(
          fieldIsEmptyNotReq,
          fieldIsValid,
          currentEmailUnique,
        );
      } else if (fieldIsValid && apiFail === true) {
        msgData = this.setFieldStatus(
          fieldIsEmptyNotReq,
          fieldIsValid,
          null,
          apiFail,
        );
      }
    }

    return (
      <Row className={element.id}>
        <Col className={element.colLabelClassName} width={colLayout[1]}>
          <label id={element.id + "-label"} htmlFor={element.id}>
            {element.label}
          </label>
        </Col>
        <Col className={element.colFieldClassName} width={colLayout[2]}>
          <input
            id={element.id}
            name={element.name}
            className={fieldMetadata.status}
            type="email"
            placeholder={element.placeHolder}
            onChange={this.handleChange}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            maxLength={maxLength}
            defaultValue={fieldMetadata.value}
            autoComplete={fieldMetadata.autocomplete || null}
          />
          <Icon {...iconProps} />
        </Col>
        <Col className={element.colValidationClassName} width={colLayout[3]}>
          <ValidationMsg
            who={element.name}
            filterFields={[element.name]}
            msgs={msgData}
          />
        </Col>
      </Row>
    );
  }
}

Email.propTypes = {
  colLayout: PropTypes.object.isRequired,
  element: PropTypes.object.isRequired,
  onEventCallback: PropTypes.func,
  fieldMetadata: PropTypes.object.isRequired,
  updateAsyncState: PropTypes.func.isRequired,
  userType: PropTypes.string.isRequired,
  site: PropTypes.string,
  verifyEmailPath: PropTypes.string,
  emailEsignMsg: PropTypes.string,
  emailRequiredMsg: PropTypes.string,
  emailAPIErrorMsg: PropTypes.string,
  emailNotUniqueMsg: PropTypes.string,
  emailReqInfoMsg: PropTypes.string,
  inEmailVerificationPilot: PropTypes.bool,
};

export default Email;

require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/src/pages/borrower-registration/styles/borrower-registration.scss');